export * from './lib/ngx-getavataaars.module';
export * from './lib/get-avatar/get-avatar.component';
